var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-header-wrapper padding-rb" },
        [
          _c(
            "PageHeader",
            { attrs: { title: "Customer List" } },
            [
              _c("el-input", {
                directives: [
                  {
                    name: "debounce",
                    rawName: "v-debounce",
                    value: _vm.onSearch,
                    expression: "onSearch",
                  },
                ],
                attrs: {
                  "prefix-icon": "el-icon-search",
                  placeholder: "Search",
                  clearable: "",
                },
                on: { clear: _vm.onSearch },
                model: {
                  value: _vm.searchVal,
                  callback: function ($$v) {
                    _vm.searchVal = $$v
                  },
                  expression: "searchVal",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              ref: "table",
              attrs: {
                data: _vm.tableData,
                "element-loading-text": "Loading...",
              },
              on: { "sort-change": _vm.onSortChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "No",
                  width: "80",
                  label: "No.",
                  sortable: "custom",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "SEName",
                  label: "Customer Name",
                  "min-width": "160",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "City",
                  label: "City",
                  "min-width": "80",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "hospital",
                  label: "Hospital / Institution",
                  "min-width": "180",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Department",
                  label: "Department",
                  "min-width": "140",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "MLName",
                  label: _vm.leaderLabel,
                  "min-width": "120",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Teamname",
                  label: "Team",
                  "min-width": "130",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Certified",
                  width: "110",
                  label: "Certified",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.tagTypeParser(row.Active),
                              effect: "dark",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.tagLabelParser(row.Active)) + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Operation",
                  width: "100",
                  prop: "StatusDesc",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "OptionMenu",
                          {
                            attrs: {
                              icon: "iconfont icon-more-menu",
                              iconSize: "18",
                            },
                          },
                          [
                            _c("OptionMenuItem", {
                              attrs: {
                                icon: "iconfont icon-read",
                                title: "View",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$router.push(
                                    `/customer/${row.SEID}/${row.MLID}`
                                  )
                                },
                              },
                            }),
                            _c("OptionMenuItem", {
                              attrs: {
                                icon: "iconfont icon-qrcode",
                                title: "QR Code",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.getQRCode(row)
                                },
                              },
                            }),
                            row.Active == 2
                              ? _c("OptionMenuItem", {
                                  attrs: {
                                    icon: "iconfont el-icon-s-claim",
                                    title: "Resend Term",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goToResendTerm(row)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "pager-count": _vm.pagerCount,
                  "page-sizes": [10, 25, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("QRCodeDialog", {
        attrs: {
          title: "Customer",
          visible: _vm.qrcodeDialogVisible,
          data: _vm.rowData,
        },
        on: {
          "update:visible": function ($event) {
            _vm.qrcodeDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.rowData = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }